/*
 * @Author: your name
 * @Date: 2021-10-11 11:44:01
 * @LastEditTime: 2021-10-15 15:30:45
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \mrc\src\service\api\staffType.js
 */
//员工关系配置
import http from '../httpConfig'

const table = "mrbase_sys_staff_correlation"

// 员工关系配置列表
export const staff_relation_config_list = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/staff-correlation/list-correlation/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

// 新增员工关系配置
export const staff_relation_config_add = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/staff-correlation/add-correlation/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

// 修改员工关系配置
export const staff_relation_config_edit = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/staff-correlation/update-correlation/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

// 查询员工关系配置详情
export const staff_relation_config_detail = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/staff-correlation/find-correlation/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

// 删除员工关系配置
export const staff_relation_config_delete = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/staff-correlation/delete-correlation/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

// 获取员工下拉列表数据
export const get_staff_list = (params = {}) => {
  // params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/staff-manager/find-staff-bossAndRole/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

